<svg [class.me-2]="position === 'left'" [class.ms-2]="position === 'right'"
     xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 1 24 24' width='24px' fill='currentColor'>
  <path d='M0 0h24v24H0z' fill='none' />
  <path d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' />
</svg>